export default "__VITE_ASSET__F0w5Sz_2__"